import { useMapEvents } from 'react-leaflet';
import { useRef } from 'react';
import { useMapContext } from '../../context/map-context';

export const MapEvents = ():null => {
  const { onSkipSelectedGroup } = useMapContext();
  const previousZoomLevel = useRef(null); // To store the last zoom level

  useMapEvents({
    zoomend: (e) => {
      const map = e.target;
      const currentZoom = map.getZoom();
      if (previousZoomLevel.current !== null && currentZoom < previousZoomLevel.current) {
        onSkipSelectedGroup();
      }

      previousZoomLevel.current = currentZoom;
    },
  });

  return null;
};
